import React, { Component } from "react";
import InlineOrderedBox from "./components/InlineOrderedBox";
import { graphql } from "react-apollo";
import { queryGetSinglePeakTime } from "Apollo";
import { GetAnalyticFilter } from "Store";
import { observer } from "mobx-react";

const gqlOptions = {
  options: {
    fetchPolicy: "network-only"
  }
};

const Box = graphql(queryGetSinglePeakTime, gqlOptions)(
  class PeakTimeSummary extends Component {
    shortDayToLongDay(short) {
      return {
        mon: "monday",
        tue: "tuesday",
        wed: "wednesday",
        thu: "thursday",
        fri: "friday",
        sat: "saturday",
        sun: "sunday"
      }[short];
    }

    render() {
      const { data: { loading, getSinglePeakTime } } = this.props;
      let mainContent = "---";
      let infoFooter = "";
      if (!loading && getSinglePeakTime) {
        if (getSinglePeakTime.data[0]) {
          const elem = getSinglePeakTime.data[0];
          let day = elem.name;
          let { name, value } = elem.details[0];
          let hour = name < 23 ? `${name}-${parseInt(name, 10) + 1}` : `${name}-0`;
          let fullDay = this.shortDayToLongDay(day.toLowerCase());
          if (value > 0) {
            infoFooter = `${fullDay} | ${value} streams`;
            mainContent = hour;
          }
        }
      }
      const opt = {
        contentList: [
          {
            title: "Peak Time",
            mainContent,
            footer: {
              text: infoFooter
            }
          }
        ],
        size: "large"
      };
      return <InlineOrderedBox {...opt} />;
    }
  }
);

export default observer(
  class BoxWithQuery extends Component {
    render() {
      return <Box {...GetAnalyticFilter()} />;
    }
  }
);



// WEBPACK FOOTER //
// ./src/module-analytics/PeakTimeSummary.js